<template>
  <ModalWithHeaderAndBody
    @close="$emit('close')"
    title="Manage reviews"
    :disable-backdrop-click="false"
    :custom-classes="['max-w-5xl']"
    gray
    v-slot="modalProps"
  >
    <BaseFetchData :action="loadData" v-slot="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="space-y-8">
        <div class="space-y-4">
          <h3 class="text-lg font-medium">Approval Claims</h3>
          <ApprovalClaimManager
            ref="approvalClaimManager"
            :project-asset="projectAsset"
            @approval-claim-manager-changed="onApprovalClaimManagerChanged"
          />
        </div>
        <div class="space-y-4">
          <h3 class="text-lg font-medium">Approval Requests</h3>
          <ApprovalRequestManager
            ref="approvalRequestManager"
            :project-asset="projectAsset"
            @approval-request-manager-changed="onApprovalRequestManagerChanged"
          />
        </div>
      </div>

      <template v-else-if="fetchDataProps.status.rejected">
        Something went wrong
        <BaseButton primary small @click="modalProps.close"> Close </BaseButton>
      </template>
    </BaseFetchData>
  </ModalWithHeaderAndBody>
</template>

<script>
import ModalWithHeaderAndBody from 'Components/ModalWithHeaderAndBody.vue';
import { projectAssetsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ApprovalClaimManager from './ManageReviewsModal/ApprovalClaimManager.vue';
import ApprovalRequestManager from './ManageReviewsModal/ApprovalRequestManager.vue';

export default {
  components: { ModalWithHeaderAndBody, ApprovalClaimManager, ApprovalRequestManager },
  name: 'ManageProjectAssetReviewsModal',
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projectAsset: null,
    };
  },
  methods: {
    async loadData() {
      try {
        const response = await this.fetchProjectAsset();

        this.setProjectAsset(response.data.data);
      } catch (error) {
        //
      }
    },
    fetchProjectAsset() {
      return projectAssetsClient.read(this.projectAssetId, {
        params: {
          include: ['approvalClaimsCount', 'approvalRequestsCount'],
        },
      });
    },
    setProjectAsset(projectAsset = null) {
      if (!projectAsset) {
        return;
      }

      this.projectAsset = mapKeysToCamelCase(projectAsset);
    },
    onApprovalClaimManagerChanged() {
      this.$refs.approvalRequestManager.fetchApprovalRequests();
      this.$emit('change');
    },
    onApprovalRequestManagerChanged() {
      this.$refs.approvalClaimManager.fetchApprovalClaims();
      this.$emit('change');
    },
  },
};
</script>
